export const PHONE_NUMBER = '8 (800) 100-40-76';
export const PHONE_NUMBER_LINK = '88001004076';
export const EMAIL = 'order@olevaro.ru';
